import type { IFormConfig } from "./types";

export const defineForm = (config: IFormConfig): IFormConfig => config;
